import { useMemo } from 'react';

import { useAppSelector } from '@store';

export const CT_URL_LINK = 'po://ct/user-logout';

export const useCounterTerminal = () => {
  const { navigatedFromCT: isFromCtSimulator } = useAppSelector((state) => state.counter);

  const isElectron = useMemo(() => typeof window !== 'undefined' && !!window.electronAPI, []);
  const isFromCT = useMemo(() => isElectron || isFromCtSimulator, [isElectron, isFromCtSimulator]);

  return { isFromCT, isElectron, isFromCtSimulator };
};
